// Malá část menu, kterou potřebuje levá lišta (hlavní balík): akce správy oficiálního menu a piktogramy z GET /ja/menu.
// Úpravy menu (Nastavení › Menu) jsou v `menu.ts` a stahují se až s tou obrazovkou.
import { useQuery } from '@tanstack/react-query';
import { api } from './klient';

/** Akce zápisu oficiálního menu (08 §3.17; admin). */
export const AKCE_MENU_OFICIALNI = 'nastaveni.menu_oficialni';

/** Klíč dotazu na piktogramy menu (GET /ja/menu) — po uložení menu se zneplatní. */
export const KLIC_IKONY_MENU = ['ja', 'menu'] as const;

function mapa(hodnota: unknown): Record<string, string> {
  if (!hodnota || typeof hodnota !== 'object' || Array.isArray(hodnota)) return {};
  const vysledek: Record<string, string> = {};
  for (const [k, v] of Object.entries(hodnota)) if (typeof v === 'string') vysledek[k] = v;
  return vysledek;
}

/**
 * Piktogramy menu pro lištu (GET /ja/menu — čte každý přihlášený); dokud nepřijdou (nebo server cestu nezná), platí
 * výchozí z `IKONA_SEKCE`.
 */
export function useIkonyMenu(): Record<string, string> {
  const dotaz = useQuery({
    queryKey: KLIC_IKONY_MENU,
    queryFn: ({ signal }) => api.get<{ ikony?: Record<string, string> }>('/ja/menu', { signal }),
    staleTime: 60_000,
    retry: false,
  });
  return mapa(dotaz.data?.ikony);
}
